// Flapjack Search — drop-in replacement for algoliasearch
// Re-exports @flapjack-search/client-search with a friendlier factory name.

import type { ClientOptions } from '@flapjack-search/client-common';
import { searchClient } from '@flapjack-search/client-search';
import type { SearchClient } from '@flapjack-search/client-search';

export type { SearchClient } from '@flapjack-search/client-search';
export { apiClientVersion } from '@flapjack-search/client-search';
export * from './models';

export type FlapjackSearch = SearchClient & {
  get _ua(): string;
  addAlgoliaAgent(segment: string, version?: string): void;
};

export function flapjackSearch(
  appId: string,
  apiKey: string,
  options?: ClientOptions | undefined,
): FlapjackSearch {
  const client = searchClient(appId, apiKey, options);

  return {
    ...client,
    get _ua(): string {
      return client.transporter.flapjackAgent.value;
    },
    addAlgoliaAgent(segment: string, version?: string): void {
      client.addFlapjackAgent(segment, version);
    },
  };
}
